module.exports = __webpack_public_path__ + "img/mes-capture-dashboard.275d7bec.png";